import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

export default function NothingHere () {
    const { t } = useTranslation()

	return (
		<div className="d-flex align-items-center justify-content-center" style={{minHeight: '100vh'}}>
			<Container>
				<Row>
					<Col xs={12} md={6} className='mx-auto text-center'>
						<h1 style={{fontSize: 80, fontWeight: 700, letterSpacing: '-0.04em', marginBottom: 8, color: '#D1D5DB'}}>...</h1>
						<h2 className='mb-3'>{t('global.nothinghere')}</h2>
						<p className="page-subtitle mb-4">{t('global.nothingheremessage') || 'There is nothing in this section.'}</p>
						<Link to="/" className='btn btn-primary'>{t('global.gotohome')}</Link>
					</Col>
				</Row>
			</Container>
		</div>
	)
}